// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"289":"325e5c15","353":"1f07f6fc","536":"b56f20a4","787":"37f46071","850":"f07e31c5"}[chunkId] + ".chunk.js";
};